module.exports = __webpack_public_path__ + "img/q1-victim.805b48d0.svg";